<template>
    <Breadcrumbs main="Bootstrap Tables" title="Table Components" />
    <div class="container-fluid">
        <div class="row">
            <uiTable />
            <alertComponent />
            <progressbarComponent />
            <checkboxComponent />
            <radioButtons />
            <selectComponent />
            <inputComponent />
            <badgesComponent />
            <tootipComponent />
            <switchComponent />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const uiTable = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/uiTable.vue"))
const alertComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/alertComponent.vue"))
const progressbarComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/progressbarComponent.vue"))
const checkboxComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/checkboxComponent.vue"))
const radioButtons = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/radioButtons.vue"))
const selectComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/selectComponent.vue"))
const inputComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/inputComponent.vue"))
const badgesComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/badgesComponent.vue"))
const tootipComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/tootipComponent.vue"))
const switchComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/switchComponent.vue"))
</script>